import {
  ODataHeader,
  ODataString,
  ODataDate
} from "pbas-vue-components";

import { translate2 } from '../trans2'

const MemberHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 1
  }),
  new ODataHeader({
    type: new ODataString("PlanIdentityId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("PlanIdentity/Current/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
   }),
   new ODataHeader({
    type: new ODataString("PlanIdentity/Current/Name"),
    visible: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.plan",
    type: new ODataString("PlanIdentity/Current/Translations[]/Name", {
      getString: (item) => translate2(item.PlanIdentity.Current, "Name")
    }),
    sortable: false,
    visible: true,
    searchable: true,
   }),
   new ODataHeader({
    title: "headers.members_management.Certificate",
    type: new ODataString("MemberIdentification/Certificate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.members_management.First Name",
    type: new ODataString("CurrentMember/FirstName"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.members_management.Last Name",
    type: new ODataString("CurrentMember/LastName"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
export default MemberHeaders;